// extracted by mini-css-extract-plugin
module.exports = {"fatSplitter":"fat-splitter_fatSplitter__2pbu9"};